var lx = window.lx || {};
window.lx = lx;

lx.payment = lx.payment || {};
lx.payment.product = lx.payment.product || {};

lx.payment.orderSummary = function (pSeat, pSto, pBillingCycle) {
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=Stripe_OrderSummary",
            x01: pSeat,
            x02: pSto,
            x03: pBillingCycle
        },
        success: function (d) {
            $("#uiCharge").html(d);
        }
    });
};

lx.payment.product.cancel = function (pSubscId) {
    apex.server.process(
        "CANCEL_SUBSCRIPTION",
        {
            x01: pSubscId
        },
        {
            success: function () {
                apex.message.showPageSuccess("Subscription Cancelled Successfully!");
                apex.region("SUBSCRIPTION-FR").refresh();
            },
            error: function (request, status, error) {
                console.error("AJAX Error:", error);
            }
        }
    );
};

lx.payment.WebshopPaymentIntent = function () {
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=Stripe_Webshop_Checkout"
        },
        success: function (d) {
            $("#uiCard").html(d);
        }
    });
};

lx.payment.callProcess = function (pName, pData) {
    return new Promise(function (resolve, reject) {
        apex.server.process(
            pName,
            pData,
            {
                dataType: "json",
                success: function (pResult) {
                    resolve(pResult);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    reject(new Error(errorThrown || textStatus || "Ajax request failed."));
                }
            }
        );
    });
};

lx.payment.subscribe1305 = async function () {
    var lMessage$  = $("#subscription-message");
    var lButton$   = $("#subscribe-button");
    var lKey       = $v("P1305_STRIPE_PUBLISHABLE_KEY");
    var lCardId    = $v("P1305_CARD_PAYMENT");
    var lSeatEmp   = $v("P1305_SEAT_EMP");
    var lSeatSto   = $v("P1305_SEAT_STO");
	var lBillingCycle = $v("P1305_BILLING_CYCLE");
    var lSpinner$  = null;
    var lOldHtml   = lButton$.html();

    function showError(pMsg) {
        lMessage$.html(
            '<div class="uiCard-error">' + apex.util.escapeHTML(pMsg) + '</div>'
        );
    }

    function showInfo(pMsg) {
        lMessage$.html(
            '<div class="uiCard-success" style="background:#f8f9fc;color:#344054;border-color:#d0d5dd;">'
            + apex.util.escapeHTML(pMsg) +
            '</div>'
        );
    }

    function setBusy(pMsg) {
        lButton$
            .prop("disabled", true)
            .attr("aria-busy", "true")
            .html('<span class="fa fa-spinner fa-anim-spin" aria-hidden="true"></span> Processing...');

        showInfo(pMsg || "Your subscription is being processed. Please wait...");

        if (!lSpinner$) {
            lSpinner$ = apex.util.showSpinner($("#ParentCont"));
        }
    }

    function clearBusy() {
        lButton$
            .prop("disabled", false)
            .removeAttr("aria-busy")
            .html(lOldHtml);

        if (lSpinner$) {
            lSpinner$.remove();
            lSpinner$ = null;
        }
    }

    try {
        if (!lCardId) {
            showError("Please select a saved card first.");
            return;
        }

        if (!lKey) {
            showError("Stripe publishable key is missing.");
            return;
        }

        setBusy("Creating your subscription...");

        var stripe = Stripe(lKey);

		var lStart = await lx.payment.callProcess(
			"Stripe_Linxpot_Start",
			{
				x01: lSeatEmp,
				x02: lSeatSto,
				x03: lCardId,
				x04: lBillingCycle
			}
		);

        if (!lStart || lStart.success !== true) {
            throw new Error((lStart && lStart.message) || "Unable to start subscription.");
        }

        if (Array.isArray(lStart.actions)) {
            for (const lAction of lStart.actions) {
                var lStatus = lAction.pi_status || "";

                if (lStatus === "requires_action" || lStatus === "requires_confirmation") {
                    showInfo("Additional bank authentication is required. Please complete 3D Secure...");

                    var lConfirm = await stripe.confirmCardPayment(lAction.client_secret);

                    if (lConfirm.error) {
                        throw new Error(lConfirm.error.message || "3D Secure authentication failed.");
                    }

                    if (
                           !lConfirm.paymentIntent
                        || ["succeeded", "processing"].indexOf(lConfirm.paymentIntent.status) === -1
                    ) {
                        throw new Error(
                            "Payment was not completed. Current Stripe status: "
                            + (lConfirm.paymentIntent ? lConfirm.paymentIntent.status : "unknown")
                        );
                    }
                }
                else if (lStatus && ["succeeded", "processing"].indexOf(lStatus) === -1) {
                    throw new Error("Unexpected Stripe payment status: " + lStatus);
                }
            }
        }

        showInfo("Finalizing your subscription...");

        var lFinish = await lx.payment.callProcess(
            "Stripe_Linxpot_Finalize",
            {
                x01: lStart.order_id
            }
        );

        if (!lFinish || lFinish.success !== true) {
            throw new Error((lFinish && lFinish.message) || "Unable to finalize subscription.");
        }

        showInfo(lFinish.message || "Subscription activated successfully.");
        window.location.reload();
    }
    catch (e) {
        clearBusy();
        showError(e.message || "Unexpected error during subscription.");
    }
};


lx.payment.cancel1305 = async function () {
    var lSpinner$ = null;

    try {
        lSpinner$ = apex.util.showSpinner($("#ParentCont"));

        var lResult = await lx.payment.callProcess(
            "Stripe_Linxpot_Cancel",
            {}
        );

        if (!lResult || lResult.success !== true) {
            throw new Error(
                (lResult && lResult.message) || "Unable to cancel subscription."
            );
        }

        apex.navigation.redirect(
            "f?p=" + $v("pFlowId") +
            ":1309:" + $v("pInstance") +
            "::NO::P1309_REGION:C"
        );
    }
    catch (e) {
        if (lSpinner$) {
            lSpinner$.remove();
        }

        apex.message.clearErrors();
        apex.message.showErrors([
            {
                type: "error",
                location: ["page"],
                message: e.message || "Unexpected error while cancelling subscription.",
                unsafe: false
            }
        ]);
    }
};

lx.payment.subscribe120 = async function () {
    var lMessage$ = $("#subscription-message");
    var lButton$  = $("#subscribe-button-120");
    var lKey      = $v("P120_STRIPE_PUBLISHABLE_KEY");
    var lCardId   = $v("P120_CARD_PAYMENT");
    var lPayOpt   = $v("P120_PAYMENT_METHOD");
    var lPrivacy  = $v("P120_PRIVACY");
    var lOrderId  = $v("P120_ORDER_ID");
    var lAloType  = $v("P120_ALO_ID_TYPE");
    var lSpinner$ = null;
    var lOldHtml  = lButton$.html();

    function showError(pMsg) {
        lMessage$.html(
            '<div class="uiCard-error">' + apex.util.escapeHTML(pMsg) + '</div>'
        );
    }

    function showInfo(pMsg) {
        lMessage$.html(
            '<div class="uiCard-success" style="background:#f8f9fc;color:#344054;border-color:#d0d5dd;">'
            + apex.util.escapeHTML(pMsg) +
            '</div>'
        );
    }

    function setBusy(pMsg) {
        lButton$
            .prop("disabled", true)
            .attr("aria-busy", "true")
            .html('<span class="fa fa-spinner fa-anim-spin" aria-hidden="true"></span> Processing...');

        showInfo(pMsg || "Your subscription is being processed. Please wait...");

        if (!lSpinner$) {
            lSpinner$ = apex.util.showSpinner($("#t_Body_content"));
        }
    }

    function clearBusy() {
        lButton$
            .prop("disabled", false)
            .removeAttr("aria-busy")
            .html(lOldHtml);

        if (lSpinner$) {
            lSpinner$.remove();
            lSpinner$ = null;
        }
    }

    try {
        if (lPrivacy !== "Y") {
            showError("Please accept the Privacy Terms before continuing.");
            return;
        }

        if (lPayOpt !== "2125") {
            showError("Please select card payment before subscribing.");
            return;
        }

        if (!lCardId) {
            showError("Please select a saved card first.");
            return;
        }

        if (!lKey) {
            showError("Stripe publishable key is missing.");
            return;
        }

        setBusy("Creating your subscription...");

        var stripe = Stripe(lKey);

        var lStart = await lx.payment.callProcess(
            "Stripe_P120_Subscribe_Start",
            {}
        );

        if (!lStart || lStart.success !== true) {
            throw new Error((lStart && lStart.message) || "Unable to start subscription.");
        }

        if (Array.isArray(lStart.actions)) {
            for (const lAction of lStart.actions) {
                var lStatus = lAction.pi_status || "";

                if (lStatus === "requires_action" || lStatus === "requires_confirmation") {
                    showInfo("Additional bank authentication is required. Please complete 3D Secure...");

                    var lConfirm = await stripe.confirmCardPayment(lAction.client_secret);

                    if (lConfirm.error) {
                        throw new Error(lConfirm.error.message || "3D Secure authentication failed.");
                    }

                    if (
                           !lConfirm.paymentIntent
                        || ["succeeded", "processing"].indexOf(lConfirm.paymentIntent.status) === -1
                    ) {
                        throw new Error(
                            "Payment was not completed. Current Stripe status: "
                            + (lConfirm.paymentIntent ? lConfirm.paymentIntent.status : "unknown")
                        );
                    }
                }
                else if (lStatus && ["succeeded", "processing"].indexOf(lStatus) === -1) {
                    throw new Error("Unexpected Stripe payment status: " + lStatus);
                }
            }
        }

        showInfo("Finalizing your subscription...");

        var lFinish = await lx.payment.callProcess(
            "Stripe_P120_Subscribe_Finalize",
            {}
        );

        if (!lFinish || lFinish.success !== true) {
            throw new Error((lFinish && lFinish.message) || "Unable to finalize subscription.");
        }

		apex.navigation.redirect(lFinish.redirect_url);
    }
    catch (e) {
        clearBusy();
        showError(e.message || "Unexpected error during subscription.");
    }
};

lx.payment.checkout120 = async function () {
    var lMessage$    = $("#subscription-message");
    var lButton$     = $("#checkout-button-120");
    var lKey         = $v("P120_STRIPE_PUBLISHABLE_KEY");
    var lCardId      = $v("P120_CARD_PAYMENT");
    var lPayOpt      = $v("P120_PAYMENT_METHOD");
    var lPrivacy     = $v("P120_PRIVACY");
    var lOrderId     = $v("P120_ORDER_ID");
    var lAloType     = $v("P120_ALO_ID_TYPE");
    var lProductType = $v("P120_PRODUCT_TYPE");
    var lEventId     = $v("P120_EVENT_ID");
    var lShippingId  = $v("P120_SHIPPING_ID");
    var lBillingId   = $v("P120_BILLING_ID");
    var lRateId      = $v("P120_RATE_ID");
    var lSpinner$    = null;
    var lOldHtml     = lButton$.html();

    function showError(pMsg) {
        lMessage$.html(
            '<div class="uiCard-error">' + apex.util.escapeHTML(pMsg) + '</div>'
        );
    }

    function showInfo(pMsg) {
        lMessage$.html(
            '<div class="uiCard-success" style="background:#f8f9fc;color:#344054;border-color:#d0d5dd;">'
            + apex.util.escapeHTML(pMsg) +
            '</div>'
        );
    }

    function setBusy(pMsg) {
        lButton$
            .prop("disabled", true)
            .attr("aria-busy", "true")
            .html('<span class="fa fa-spinner fa-anim-spin" aria-hidden="true"></span> Processing...');

        showInfo(pMsg || "Your payment is being processed. Please wait...");

        if (!lSpinner$) {
            lSpinner$ = apex.util.showSpinner($("#t_Body_content"));
        }
    }

    function clearBusy() {
        lButton$
            .prop("disabled", false)
            .removeAttr("aria-busy")
            .html(lOldHtml);

        if (lSpinner$) {
            lSpinner$.remove();
            lSpinner$ = null;
        }
    }

    try {
        if (!lOrderId) {
            showError("Order was not found.");
            return;
        }

        if (!lPayOpt) {
            showError("Please select a payment method before checkout.");
            return;
        }

        // Keep old submit flow for non-card payments
        if (lPayOpt !== "2125") {
            apex.submit({ request: "CHECKOUT" });
            return;
        }

        // Memberships should continue using SUBSCRIBE
        if (lAloType === "178") {
            showError("Please use the Subscribe button for membership card payments.");
            return;
        }

        if (lPrivacy !== "Y") {
            showError("Please accept the Privacy Terms before continuing.");
            return;
        }

        if (!lCardId) {
            showError("Please select a saved card first.");
            return;
        }

        if (!lKey) {
            showError("Stripe publishable key is missing.");
            return;
        }

        if (lProductType !== "S" && !lEventId) {
            if (!lShippingId || !lBillingId) {
                showError("You need to select both shipping and billing addresses.");
                return;
            }

            if (!lRateId) {
                showError("Please choose a shipping method.");
                return;
            }
        }

        setBusy("Starting your payment...");

        var stripe = Stripe(lKey);

        var lStart = await lx.payment.callProcess(
            "Stripe_P120_Checkout_Start",
            {}
        );

        if (!lStart || lStart.success !== true) {
            throw new Error((lStart && lStart.message) || "Unable to start checkout.");
        }

        var lConfirm = await stripe.confirmCardPayment(
            lStart.client_secret,
            {
                payment_method: lStart.payment_method_id
            }
        );

        if (lConfirm.error) {
            throw new Error(lConfirm.error.message || "3D Secure authentication failed.");
        }

        if (
               !lConfirm.paymentIntent
            || ["succeeded", "processing"].indexOf(lConfirm.paymentIntent.status) === -1
        ) {
            throw new Error(
                "Payment was not completed. Current Stripe status: "
                + (lConfirm.paymentIntent ? lConfirm.paymentIntent.status : "unknown")
            );
        }

        showInfo("Finalizing your payment...");

        var lFinish = await lx.payment.callProcess(
            "Stripe_P120_Checkout_Finalize",
            {
                x01: lStart.payment_intent_id
            }
        );

        if (!lFinish || lFinish.success !== true) {
            throw new Error((lFinish && lFinish.message) || "Unable to finalize checkout.");
        }

        apex.navigation.redirect(lFinish.redirect_url);
    }
    catch (e) {
        clearBusy();
        showError(e.message || "Unexpected error during checkout.");
    }
};